import {NAV_DEFAULT_SEARCH_PARAMS} from './nav-default-search-params'
import {OPEN_CHANGE_PASSWORD_SEARCH_PARAM} from './open-change-password-search-param'
import {resolveNewPortalPath} from './resolve-new-portal-path'

export function buildOpenChangePasswordSearch(legacyPath: string) {
  const newPortalPath = resolveNewPortalPath(legacyPath)
  const params = new URLSearchParams()
  const defaults = NAV_DEFAULT_SEARCH_PARAMS[newPortalPath]

  if (defaults) {
    Object.entries(defaults).forEach(([key, value]) => {
      params.set(key, value)
    })
  }

  params.set(OPEN_CHANGE_PASSWORD_SEARCH_PARAM, '1')

  const queryString = params.toString()
  return queryString ? `?${queryString}` : ''
}
